<template>
    <div class="flex-row" :class="{gutters: layout.gutters}">
        <TgpZone v-for="zone in layout.zones"
                 :key="zone.name"
                 :zone="zone"
                 :url-config="urlConfig"
        />
    </div>
</template>

<script>
import TgpZone from "./TgpZone";

export default {
    name: "TgpLayout",
    components: {TgpZone},
    props: {
        layout: {type: Object, required: true},
        urlConfig: {type: Object, required: true},
    },
}
</script>

<style>
.flex-row {
    display: flex;
    flex-wrap: wrap;
}

@media (min-width: 768px) {
    .flex-row.gutters {
        margin-left: -5px;
        margin-right: -5px;
    }
}

@media (min-width: 1024px) {
    .flex-row.gutters {
        margin-left: -10px;
        margin-right: -10px;
    }
}
</style>
